import {
  faBook,
  faLayerGroup,
  faSwatchbook,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as types from './types'

const initialState = {
  editingReport: false,
  finalSlide: false,
  report: null,
  possibleColumns: [],
  currentSlide: null,
  selectedReportType: null,
  selectedCourseReportType: null,
  selectedCourseGroupReportType: null,
  exactReportType: null,
  allCourses: [],
  allCourseGroups: [],
  selectedSingleCourse: null,
  selectedMultipleCourses: [],
  selectedSingleCourseGroup: null,
  selectedMultipleCourseGroups: [],
  courseLocations: [],
  courseLocationGroups: [],
  courseGroupLocations: [],
  courseGroupLocationGroups: [],
  selectedLocations: { locations: [], type: null },
  courseRoles: [],
  courseRoleGroups: [],
  courseGroupRoles: [],
  courseGroupRoleGroups: [],
  selectedRoles: { roles: [], type: null },
  reportTypes: [
    {
      id: 0,
      title: 'Course',
      icon: <FontAwesomeIcon icon={faBook} size='3x' />,
      description:
        'Report about a course, including progress and statuses. The results can be grouped by locations, areas, and regions.',
    },
    {
      id: 1,
      title: 'Course Group',
      icon: <FontAwesomeIcon icon={faLayerGroup} size='3x' />,
      description:
        'This report aggregates data from a group of courses, providing insights across multiple courses at once.',
    },
  ],
  courseReportTypes: [
    {
      id: 0,
      title: 'Single Course',
      icon: <FontAwesomeIcon icon={faBook} size='3x' />,
      description:
        'Detailed information about a single course. The results can be grouped by locations, areas, and regions.',
    },
    {
      id: 1,
      title: 'Multiple Courses',
      icon: <FontAwesomeIcon icon={faSwatchbook} size='3x' />,
      description: 'Overview of general information about multiple courses.',
    },
  ],
  courseGroupReportTypes: [
    {
      id: 0,
      title: 'Single Course Group',
      icon: <FontAwesomeIcon icon={faBook} size='3x' />,
      description:
        'Detailed information about a single course group. The results are grouped by locations, areas, and regions.',
    },
    {
      id: 1,
      title: 'Multiple Course Groups',
      icon: <FontAwesomeIcon icon={faLayerGroup} size='3x' />,
      description:
        'Overview of general information about multiple course groups.',
    },
  ],
  previewColumns: [],
  previewRows: [],
  downloading: false,
  savingAndDownloading: false,
  savedReports: [],

  savedReportsRows: [],
  showSelectedOnly: false,
  downloadingFromMainPage: false,
  continueDisabled: true,
  continueButtonText: 'Continue',
  completedSlides: [],
  admins: [],
  emailReport: 0,
}

const customReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_CURRENT_SLIDE:
      return { ...state, currentSlide: action.payload }
    case types.SET_REPORT_TYPE:
      return { ...state, selectedReportType: action.payload }
    case types.SET_COURSE_REPORT_TYPE:
      return { ...state, selectedCourseReportType: action.payload }
    case types.SET_COURSE_GROUP_REPORT_TYPE:
      return { ...state, selectedCourseGroupReportType: action.payload }
    case types.SET_ALL_COURSES:
      return { ...state, allCourses: action.payload }
    case types.SET_ALL_COURSE_GROUPS:
      return { ...state, allCourseGroups: action.payload }
    case types.SET_SINGLE_COURSE:
      return { ...state, selectedSingleCourse: action.payload }
    case types.SET_SINGLE_COURSE_GROUP:
      return { ...state, selectedSingleCourseGroup: action.payload }
    case types.SET_COURSE_LOCATIONS:
      return { ...state, courseLocations: action.payload }
    case types.SET_COURSE_LOCATION_GROUPS:
      return { ...state, courseLocationGroups: action.payload }
    case types.SET_COURSE_GROUP_LOCATIONS:
      return { ...state, courseGroupLocations: action.payload }
    case types.SET_COURSE_GROUP_LOCATION_GROUPS:
      return { ...state, courseGroupLocationGroups: action.payload }
    case types.SET_SELECTED_LOCATIONS:
      return { ...state, selectedLocations: action.payload }
    case types.SET_COURSE_ROLES:
      return { ...state, courseRoles: action.payload }

    case types.SET_COURSE_ROLE_GROUPS:
      return { ...state, courseRoleGroups: action.payload }
    case types.SET_COURSE_GROUP_ROLES:
      return { ...state, courseGroupRoles: action.payload }
    case types.SET_COURSE_GROUP_ROLE_GROUPS:
      return { ...state, courseGroupRoleGroups: action.payload }
    case types.SET_SELECTED_ROLES:
      return { ...state, selectedRoles: action.payload }
    case types.RESET_SELECTED_ROLES:
      return {
        ...state,
        selectedRoles: {
          ...state.selectedRoles,
          roles: [],
          type: null,
        },
      }
    case types.RESET_SELECTED_LOCATIONS:
      return {
        ...state,
        selectedLocations: {
          ...state.selectedLocations,
          locations: [],
          type: null,
        },
      }
    case types.SET_PREVIEW_COLUMNS: {
      return { ...state, previewColumns: action.payload }
    }
    case types.SET_PREVIEW_ROWS: {
      return { ...state, previewRows: action.payload }
    }
    case types.RESET_EVERYTHING:
      return { ...initialState }

    case types.SET_POSSIBLE_COLUMNS:
      return { ...state, possibleColumns: action.payload }

    case types.SET_DOWNLOADING:
      return { ...state, downloading: action.payload }

    case types.SET_SAVING_DOWNLOADING:
      return { ...state, savingAndDownloading: action.payload }

    case types.SET_SAVED_REPORTS:
      return { ...state, savedReports: action.payload }

    case types.SET_SAVED_REPORTS_ROWS:
      return { ...state, savedReportsRows: action.payload }

    case types.SET_EDITING_REPORT:
      return { ...state, editingReport: action.payload }

    case types.SET_FILTER_SELECTED_ONLY:
      return { ...state, showSelectedOnly: action.payload }

    case types.SET_REPORT:
      return { ...state, report: action.payload }

    case types.SET_DOWNLOADING_FROM_MAIN_PAGE:
      return { ...state, downloadingFromMainPage: action.payload }

    case types.SET_MULTIPlE_COURSES:
      return { ...state, selectedMultipleCourses: action.payload }

    case types.SET_MULTIPLE_COURSE_GROUPS:
      return { ...state, selectedMultipleCourseGroups: action.payload }

    case types.SET_CONTINUE_DISABLED:
      return { ...state, continueDisabled: action.payload }

    case types.SET_CONTINUE_BUTTON_TEXT:
      return { ...state, continueButtonText: action.payload }

    case types.SET_EXACT_REPORT_TYPE:
      return { ...state, exactReportType: action.payload }

    case types.SET_FINAL_SLIDE:
      return { ...state, finalSlide: action.payload }

    case types.SET_COMPLETED_SLIDES:
      return { ...state, completedSlides: action.payload }

    case types.SET_ADMINS:
      return { ...state, admins: action.payload }

    case types.SET_EMAIL_REPORT:
      return { ...state, emailReport: action.payload }

    default:
      return state
  }
}

export default customReportsReducer
